import TimelyLogo from 'images/apps_logo/timely.svg';
import { TIMELY_TOOL_ID } from './linkedWorkItems.helpers';

/**
 * What an `Image` shows when a linked-work icon fails to load. A native item's `icon_url` is
 * whatever the API client sent, so it may point at a page or a host that refuses hotlinking; those
 * fall back to the Timely logo, same as an item sent without one. TIC tool icons render nothing
 * rather than a broken image.
 */
export const linkedWorkIconFallback = (toolId: string | null | undefined): string | false =>
  toolId === TIMELY_TOOL_ID ? TimelyLogo : false;
